import { useMemo } from 'react';

const usePendingExams = (unfinishedExams, medicalConsultationDetails, disableForm) => {
  return useMemo(() => {
    return !!(unfinishedExams &&
      (
        ["unableToSign", "incomplete"].includes(medicalConsultationDetails?.state)
        || unfinishedExams.some(exam => exam.procedures || exam.measurements || exam.missing_expert_sign)
        || !!disableForm
        || (medicalConsultationDetails?.pending_reasons && medicalConsultationDetails.pending_reasons.length > 0)
      ));
  }, [unfinishedExams, medicalConsultationDetails, disableForm]);
};

export default usePendingExams;
